export default __webpack_public_path__ + "static/media/pastry-desktop.d0c25f6a.png";